import { useEffect, useState } from "react";

export default function BackToTop() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <button
      type="button"
      aria-label="回到顶部"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className={`fixed bottom-6 right-5 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary-600 text-background-50 shadow-lg transition-all hover:bg-primary-700 ${
        show ? "opacity-100" : "pointer-events-none opacity-0"
      }`}
    >
      <i className="ri-arrow-up-line text-lg" />
    </button>
  );
}